<template>
  <el-dialog :visible.sync="editorShow" title="编辑" width="800px" ref="dialog" @close="editorClose">
    <EditModal ref="editModal" @onSubmit="onModalSubmit"/>
  </el-dialog>
</template>

<script>
import EditModal from './editModal'
export default {
  components: {
    EditModal
  },
  data() {
    return {
      editorShow: false,
    }
  },
  methods: {
    open(details) {
      this.editorShow = true
      this.$nextTick(() => {this.$refs.editModal.setData(details)})
    },
    editorClose() {
      this.editorShow = false
    },
    onModalSubmit(val){
      this.$emit('onSubmit', val)
    },
  }
}
</script>

